var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('markdown-document-modal'),_c('sharing-modal'),_c('app-share-modal'),_c('jit-enable-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }